<template>
  <div>
    <h5 class="headline">
      {{ $t("contract.distributor_rights_and_obligations.headline") }}
    </h5>
    <p>{{ $t("contract.distributor_rights_and_obligations.paragraph_one") }}</p>
    <p v-if="shouldParticipate">
      {{
        $t("contract.distributor_rights_and_obligations.paragraph_two", {
          yearlyFairs: numberOfFairs
        })
      }}
    </p>
    <p v-else>
      {{
        $t("contract.distributor_rights_and_obligations.paragraph_two_no_fair")
      }}
    </p>
    <p>
      {{
        $t("contract.distributor_rights_and_obligations.paragraph_three", {
          marketingPercent: marketingPercent
        })
      }}
    </p>
    <p
      v-html="$t('contract.distributor_rights_and_obligations.paragraph_four')"
    ></p>
    <p>
      {{ $t("contract.distributor_rights_and_obligations.paragraph_five") }}
    </p>
    <p>{{ $t("contract.distributor_rights_and_obligations.paragraph_six") }}</p>
    <p>
      {{ $t("contract.distributor_rights_and_obligations.paragraph_seven") }}
    </p>
    <p>
      {{ $t("contract.distributor_rights_and_obligations.paragraph_eight") }}
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    numberOfFairs() {
      let numberOfFairs = this.$store.state.contract
        .distributorRightsAndObligations.numberOfFairs;
      if (numberOfFairs !== "") {
        if (Number(numberOfFairs) === 1)
          return this.$t(
            "contract.distributor_rights_and_obligations.fairs.singular"
          );
        else
          return this.$t(
            "contract.distributor_rights_and_obligations.fairs.plural",
            { n: numberOfFairs }
          );
      } else {
        return this.$t(
          "contract.distributor_rights_and_obligations.placeholder.fairs"
        );
      }
    },
    shouldParticipate() {
      return this.$store.state.contract.distributorRightsAndObligations
        .shouldParticipate;
    },
    marketingPercent() {
      let marketingPercent = this.$store.state.contract
        .distributorRightsAndObligations.marketingPercent;
      return marketingPercent !== ""
        ? marketingPercent
        : this.$t(
            "contract.distributor_rights_and_obligations.placeholder.marketingPercent"
          );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/DistributorRightsAndObligationsOutput.vue